<div #dropdownList  class="db-dropdown-list {{className}}" [ngStyle]="dropdownListStyle" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div class="db-dropdown-list__content">
    <div>
      <ul>
        <li *ngFor="let item of items"><a class="db-dropdown-list__item {{item.className}}" (click)="onItemClick($event, item)"><i class="db-icon db-icon-{{item.icon}}" *ngIf="item.icon"></i><span>{{item.label}}</span></a></li>
      </ul>
    </div>
  </div>
</div>
